import { SourcingCandidateTableColumns } from 'modules/sourcing-shared/tables/types/SourcingCandidateTable';
import { CandidateSource } from 'generated-graphql/types';
import { SearchSourcingCandidateQueryItem } from '../types/SearchSourcingCandidateQueryItem';
import { getAnalysisTitle } from 'utils/getAnalysisTitle';

const getOrigin = (source: CandidateSource | null | undefined): string => {
  if (!source) return '-';
  return source === CandidateSource.ExternallySourcedViaContactOut
    ? 'Popp external'
    : 'Popp internal';
};

export const mapSourcingCandidateDataToTableColumns = (
  data: SearchSourcingCandidateQueryItem[]
): SourcingCandidateTableColumns[] =>
  data.map((item) => ({
    id: item.id,
    status: item.status,
    name: item.fullName ?? '',
    location: item.location ?? '',
    phone: item.phoneNumber ?? '',
    phoneNumber: item.phoneNumber ?? null,
    fetchPhoneNumberAttempted: item.fetchPhoneNumberAttempted ?? false,
    linkedInProfileUrl: item.linkedInProfileUrl,
    origin: getOrigin(item.source),
    candidateId: item.candidateId ?? null,
    candidateBatchId: item.candidateBatchId,
    conversationId: item.conversationId ?? null,
    conversationRepliesCount: item.conversationRepliesCount ?? 0,
    conversationStatus: item.conversationStatus ?? null,
    conversationNeedsReview: item.conversationNeedsReview ?? false,
    candidateBatchStatus: item.candidateBatch?.status ?? null,
    candidateBatchJobTitle: getAnalysisTitle(item.candidateBatch) || null
  }));
